import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAsyncError, useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Select from "react-select";
import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { toast } from "react-toastify";
import moment from "moment";
import * as Yup from "yup";
import { FaSpinner } from "react-icons/fa";

const AssetReturnAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Asset Return"));
  }, []);

  const initialFormData = [
    {
      TXNDate: "",
      EmployeeID: 0,
      lines: [],
    },
  ];

  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(true);
  const [empListOption, setEmpListOption] = useState([]);
  const [selectedReturendFrom, setSelectedReturendFrom] = useState("");
  const [empListData, setEmpListData] = useState([]);
  const [errors, setErrors] = useState({});
  const [pageLoading, setPageLoading] = useState(true);
  const [assetLocationOpt, setAssetLocationOpt] = useState([]);
  const [reusableOption, setReusableOption] = useState([]);

  useEffect(() => {
    fetchGetAssetReturnMaster();
  }, []);

  const fetchGetAssetReturnMaster = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}asset-return?P_EmployeeID=0`
      );
      if (response.status === 200) {
        const cleanedData = response?.data;

        const empList = cleanedData?.empList?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setEmpListOption(empList);

        const incApp = Object.entries(cleanedData?.incApp).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );
        setReusableOption(incApp);

        const locationOpt = Object.entries(cleanedData?.location || {}).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );
        setAssetLocationOpt(locationOpt);
        setPageLoading(false);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Vendor Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Vendor Master:", error);
    }
  };

  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}asset-return/${selectedReturendFrom.value}`
      );
      setEmpListData(response?.data?.data?.assets);
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.assets;

        setFormData((prevState) => ({
          ...prevState, // Spread the previous state to retain other properties
          EmployeeID: selectedReturendFrom.value,
          lines: cleanedData?.map((ele, index) => ({
            ID: ele?.ID,
            LineNo: ele?.LineNo,
            BatchNo: ele?.BatchNo,
            AssetID: ele?.AssetID, // Ensure this is a string if needed
            AssetName: ele?.AssetName,
            CategoryID: ele?.CategoryID,
            CategoryName: ele?.CategoryName,
            TXNDate: ele?.TXNDate,
            MRP: ele?.MRP,
            Quantity: ele?.Quantity,
            QuantityAllocated: ele?.QuantityAllocated,
            Reusable: ele?.Reusable,
            Location: ele?.Location,
            Remarks: ele?.Remarks,
            AssetReturnDate: ele?.AssetReturnDate,
          })),
        }));

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Disposed Report. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Disposed Report:", error);
    }
  };

  const handleChange = async (e, index) => {
    const { name, type, checked, value } = e.target;
    const updatedLines = [...formData.lines];
    const newValue = type === "checkbox" ? checked : value;

    updatedLines[index] = {
      ...updatedLines[index],
      [name]: newValue,
    };

    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));
  };

  const [checkedItem, setCheckedItem] = useState([]);

  const handleCheckboxChange = (e, ele) => {
    let arr = [...checkedItem];
    if (e.target.checked) {
      arr.push(ele); // Add the checked item
    } else {
      arr = arr.filter((item) => item.ID !== ele.ID); // Remove unchecked item
    }
    setCheckedItem(arr);
  };

  // const handleDateChange = async (event, index) => {
  //   const { name, value } = event.target;
  //   console.log("DateChange", name, value);

  //   // Update the specific line based on index
  //   const updatedLines = [...formData.lines];
  //   updatedLines[index] = {
  //     ...updatedLines[index],
  //     [name]: value,
  //   };

  //   // Update formData state
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     lines: updatedLines,
  //   }));

  //   // Check if the line is selected for validation
  //   const currentLine = updatedLines[index];
  //   const isLineSelected = checkedItem.some((item) => item.LineNo === currentLine.LineNo);
  //   if (!isLineSelected) return; // Skip validation if the line is not checked

  //   // Update the date in the `checkedItem` list if the item is checked
  //   const updatedCheckedItems = checkedItem.map((item) =>
  //     item.ID === currentLine.ID ? { ...item, [name]: value } : item
  //   );
  //   setCheckedItem(updatedCheckedItems);

  //   // Validate the specific field
  //   const fieldName = `lines[${index}].${name}`;
  //   const updatedData = { lines: updatedLines };

  //   try {
  //     await schema.validateAt(fieldName, updatedData);
  //   } catch (err) {
  //     if (err.path === fieldName && !toast.isActive(err.message)) {
  //       toast.error(err.message, { position: "top-right" });
  //     }
  //   }
  // };

  // const handleSelect = async (selectedOption, name, index) => {
  //     // Update formData with the selected value for the SkillID
  //     console.log("select----> ", selectedOption);
  //     const updatedLines = [...formData.lines];

  //     updatedLines[index] = {
  //         ...updatedLines[index],
  //         [name]: selectedOption?.value,
  //     };
  //     setFormData((prevData) => ({
  //         ...prevData, lines: updatedLines

  //     }));
  // };
  const handleDateChange = async (event, index) => {
    const { name, value } = event.target;

    // Update the specific line based on index
    const updatedLines = [...formData.lines];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: value,
    };

    // Update formData state
    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));

    // Check if the line is selected for validation
    const currentLine = updatedLines[index];
    const isLineSelected = checkedItem.some(
      (item) => item.LineNo === currentLine.LineNo
    );
    if (!isLineSelected) return; // Skip validation if the line is not checked

    // Update the date in the `checkedItem` list if the item is checked
    const updatedCheckedItems = checkedItem.map((item) =>
      item.ID === currentLine.ID ? { ...item, [name]: value } : item
    );
    setCheckedItem(updatedCheckedItems);

    // Validate the specific field
    const fieldName = `lines[${index}].${name}`;
    const updatedData = { lines: updatedLines };

    try {
      await schema.validateAt(fieldName, updatedData);
    } catch (err) {
      if (err.path === fieldName && !toast.isActive(err.message)) {
        toast.error(err.message, { position: "top-right" });
      }
    }
  };

  const handleSelect = async (selectedOption, name, index) => {

    const updatedLines = [...formData.lines];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: selectedOption?.value,
    };
    setFormData((prevData) => ({
      ...prevData,
      lines: updatedLines,
    }));

    // Update `checkedItem` if the line is checked
    const currentLine = updatedLines[index];
    const isLineChecked = checkedItem.some(
      (item) => item.LineNo === currentLine.LineNo
    );
    if (isLineChecked) {
      const updatedCheckedItems = checkedItem.map((item) =>
        item.ID === currentLine.ID
          ? { ...item, [name]: selectedOption?.value }
          : item
      );
      setCheckedItem(updatedCheckedItems);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Ensure the latest state of checkedItem
    const latestCheckedItems = [...checkedItem];

    if (latestCheckedItems.length === 0) {
      toast.error("Please select at least one line.");
      setLoading(false);
      return;
    }

    try {
      // Prepare data for submission
      const selectedLines = latestCheckedItems.map((ele) => ({
        ID: ele?.ID,
        LineNo: ele?.LineNo,
        BatchNo: ele?.BatchNo,
        AssetID: ele?.AssetID,
        AssetName: ele?.AssetName,
        CategoryID: ele?.CategoryID,
        TXNDate: ele?.TXNDate,
        MRP: ele?.MRP,
        Quantity: 1,
        QuantityAllocated: 0,
        Reusable: ele?.Reusable,
        Location: ele?.Location,
        Remarks: ele?.Remarks,
        AssetReturnDate: ele?.AssetReturnDate
          ? moment(ele?.AssetReturnDate).format("YYYY-MM-DD")
          : "",
      }));
      // Validate only selected lines
      const selectedData = { lines: selectedLines };

      await schema.validate(selectedData, { abortEarly: false });

      // Submit only selected lines
      const response = await PostServiceCaller(
        `${API_URL}asset-return`,
        { ...formData, lines: selectedLines },
        "post"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        setTimeout(() => navigate(`/asset-return`), 2000);
      } else {
        console.error("Server responded with an error:", response.status);
      }
    } catch (error) {
      if (error.inner) {
        const displayedMessages = new Set();
        error.inner.forEach((err) => {
          if (
            !displayedMessages.has(err.message) &&
            displayedMessages.size < 4
          ) {
            displayedMessages.add(err.message);
            toast.error(err.message, { position: "top-right" });
          }
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const schema = Yup.object().shape({
    lines: Yup.array().of(
      Yup.object().shape({
        AssetReturnDate: Yup.string().required("Asset Return Date is required"),
        Location: Yup.string().required("Location is required"),
      })
    ),
  });

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <div className=" rounded bg-white" id="skill-table-area">
            <div className="row mt-2">
              <div className="col-md-6">
                <div className="col-6">
                  <label className="form-label">Returned From</label>
                  <Select
                    name="ReturnedFrom"
                    onChange={(selectedOption) =>
                      setSelectedReturendFrom(selectedOption)
                    }
                    value={selectedReturendFrom}
                    options={[{ value: "", label: "Select" }, ...empListOption]}
                  />
                </div>
              </div>
              <div className="col-md-6  pe-3 float-end mt-4">
                <button
                  type="button"
                  size="small"
                  disabled={formData?.lines?.length === 0} // Button disabled when lines length is 0
                  className={`custom-btn mt-2 float-end ${
                    formData?.lines?.length === 0 ? "custom-disable-btn" : ""
                  }`} // Add custom class when disabled
                  onClick={(e) => handleSubmit(e)} // Call handleSubmit on click
                >
                  Submit
                </button>

                <button
                  type="button"
                  size="small"
                  className="custom-btn mt-2 me-2 float-end"
                  onClick={handleGetData}
                >
                  Get Data
                </button>
              </div>
            </div>

            <div className="row mt-2 px-2 rounded">
              <div>
                <h5>{formData?.lines?.length || 0} Asset Details</h5>
              </div>

              <Table hovered bordered stripped>
                <thead id="thcolor" className="text-center">
                  <tr className="text-center">
                    <th>##</th>
                    <th>Employee Name</th>
                    <th>Category</th>
                    <th>Asset</th>
                    <th>Allocation Date</th>
                    <th>
                      Location<span className="text-danger">*</span>
                    </th>
                    <th>
                      Return Date<span className="text-danger">*</span>
                    </th>
                    <th style={{ width: "160px" }}>Return To</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {formData?.lines && formData?.lines?.length != 0 ? (
                    formData?.lines?.map((ele, index) => (
                      <tr>
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            // checked={
                            //     item.Ifexists === "1"
                            //         ? true
                            //         : item.EmployeeID
                            //             ? selectedResource.find((o) => o.EmployeeID === item.EmployeeID)
                            //                 ? true
                            //                 : false
                            //             : selectedResource.find((o) => o.ID === item.ID)
                            //                 ? true
                            //                 : false
                            // }
                            // disabled={item.Ifexists === "1"}  // Disable if item.ifExists is 1
                            onChange={(e) => handleCheckboxChange(e, ele)}
                          />
                        </td>
                        <td className="">
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            value={selectedReturendFrom.label}
                            readOnly
                            onChange={(e) => handleChange(e)}
                          />
                        </td>
                        <td className="">
                          <input
                            type="text"
                            className="form-control"
                            name="CategoryID"
                            value={ele?.CategoryName}
                            disabled
                            onChange={(e) => handleChange(e)}
                            readOnly
                          />
                        </td>
                        <td className="">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-top">
                                {ele?.AssetName}
                              </Tooltip>
                            }
                          >
                            <input
                              type="text"
                              disabled
                              name="AssetID"
                              value={ele?.AssetName}
                              className="form-control"
                              onChange={(e) => handleChange(e)}
                              readOnly
                            />
                          </OverlayTrigger>
                        </td>
                        <td className="">
                          <CustomDatePicker
                            handleChange={(e) => handleDateChange(e, index)}
                            name="TXNDate"
                            id="TXNDate"
                            className="form-control"
                            value={
                              (ele?.TXNDate &&
                                moment(ele?.TXNDate).format("DD-MMM-YYYY")) ||
                              ""
                            }
                            placeholderText="DD-MM-YYYY"
                            readOnly={true}
                          />
                        </td>
                        <td>
                          <Select
                            name="Location"
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name, index)
                            }
                            // className={`form-control ${errors?.[`lines[${index}].Location`] ? "is-invalid" : ""
                            // }`}
                            value={assetLocationOpt?.find(
                              (o) => o.value === formData?.Location
                            )}
                            options={[
                              { value: "", label: "Select" },
                              ...assetLocationOpt,
                            ]}
                          />
                          {errors?.[`lines[${index}].Location`] && ( // Accessing errors for the specific line
                            <div className="text-danger">
                              {errors[`lines[${index}].Location`]}{" "}
                              {/* Displaying the error message */}
                            </div>
                          )}
                        </td>
                        <td>
                          <div>
                            <CustomDatePicker
                              handleChange={(e) => handleDateChange(e, index)}
                              name="AssetReturnDate"
                              id="AssetReturnDate"
                              className={`form-control ${
                                errors?.[`lines[${index}].AssetReturnDate`]
                                  ? "is-invalid"
                                  : ""
                              }`}
                              value={
                                (ele?.AssetReturnDate &&
                                  moment(ele?.AssetReturnDate).format(
                                    "DD-MMM-YYYY"
                                  )) ||
                                ""
                              }
                              placeholderText="DD-MM-YYYY"
                            />
                          </div>
                          {errors?.[`lines[${index}].AssetReturnDate`] && ( // Accessing errors for the specific line
                            <div className="text-danger">
                              {errors[`lines[${index}].AssetReturnDate`]}{" "}
                              {/* Displaying the error message */}
                            </div>
                          )}
                        </td>
                        <td>
                          <Select
                            name="Reusable"
                            onChange={(selectedOption, action) =>
                              handleSelect(selectedOption, action.name, index)
                            }
                            value={reusableOption?.find(
                              (o) => o.value === formData?.Reusable
                            )}
                            options={[
                              { value: "", label: "Select" },
                              ...reusableOption,
                            ]}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="Remarks"
                            value={ele?.Remarks}
                            onChange={(e) => handleChange(e, index)}
                            className="form-control"
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default AssetReturnAdd;
